// extracted by mini-css-extract-plugin
export default {"CandidateOfferInfo":"styles_CandidateOfferInfo__aqm+9"};